import React, { useMemo, useState,useEffect } from "react";
import { PaymentStatus,OrderStatus } from "../../Dashboard/LatestTranactionCol";
import { Link } from "react-router-dom";
import { Col, Container, Row, UncontrolledTooltip } from "reactstrap";
import EcommerceOrdersModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersModal";
import EcommerceOrdersPaymentModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersPaymentModal";
import EcommerceOrdersTrackingModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersTrackingModal";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "../../../components/Common/TableContainer";
import { formatDateTime,indianCurrencyFormat } from "../../../utils/dayjs";
import "../../../assets/css/individual-cart.css";

const IndividualOrder = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;

  const [customerOrderData, setcustomerOrderData] = useState([]);
  const [error, setError] = useState(null);

  const [orderDetailsModel, setOrderDetailsModal] = useState(false);
  const [paymentDetailsModel, setPaymentDetailsModal] = useState(false);
  const [trackingDetailsModel, setTrackingDetailsModal] = useState(false);
  const toggleViewModal = () => setOrderDetailsModal(!orderDetailsModel);
  const togglePaymentDetailsViewModal = () =>
    setPaymentDetailsModal(!paymentDetailsModel);
  const toggleTrackingDetailsViewModal = () =>
    setTrackingDetailsModal(!trackingDetailsModel);
  const [statusFilter, setStatusFilter] = useState("");
    const [loading, setLoading] = useState(true);

  const fetchindividualCustomerOrder = async () => {
              try {
                setError(null);
                const response = await fetch(`${baseurl}/admin/customer/individuals-orders`);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setcustomerOrderData(data);
              } catch (error) {
                setError(error.message);
              }
            };
  
            useEffect(() => {
                        fetchindividualCustomerOrder();
                      }, []);
const filteredData = useMemo(() => {
  if (!statusFilter) return customerOrderData;

  return customerOrderData.filter(
    item => item.order_status?.toLowerCase() === statusFilter.toLowerCase()
  );
}, [customerOrderData, statusFilter]);


  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "order_id",
        filterable: true,
sortDescFirst: true,
      },{
        Header: "Company Name",
        accessor: "company_name",
        filterable: true,
      },
      {
        Header: "Customer Name",
        accessor: "user_name",
        filterable: true,
      },
      {
        Header: "Order Date & Time",
        accessor: "created_at",
        Cell: ({ value }) => formatDateTime(value),
        filterable: true,
      },
      {
        Header: "Total",
        accessor: "total_amount",
         Cell: ({ value }) => indianCurrencyFormat(value),
        filterable: true,
      },{
        Header: "Payment ID",
        accessor: "payment_id",
        
        filterable: true,
      },
      {
        Header: "Order Status",
        accessor: "order_status",
        filterable: true,
        Cell: (cellProps) => {
          return <OrderStatus {...cellProps} />;
        },
      },
      
      {
        Header: "View Details",
        disableFilters: true,
        accessor: "view",
        Cell: (cellProps) => {
          const orderId = cellProps.row.original.order_id;
          return (
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={`/manage-orders/individual-customer/order-details/${orderId}`}
                className="text-success"
              >
                <i
                  className="mdi mdi-eye-outline font-size-18"
                  id="viewtooltip"
                ></i>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              {/* <Link
                to="#"
                className="text-success"
                onClick={togglePaymentDetailsViewModal}
              >
                <i
                  className="fab fas fa-money-bill-alt font-size-14"
                  id="paymentbutton"
                />
                <UncontrolledTooltip placement="top" target="paymentbutton">
                  Payment Details
                </UncontrolledTooltip>
              </Link> */}
              {/* <Link
                to={`/manage-orders/individual-customer/order-details/${orderId}`}
                className="text-success"
              >
                <i
                  className="bx bxs-download font-size-18"
                  id="downloadtooltip"
                ></i>
                <UncontrolledTooltip placement="top" target="downloadtooltip">
                  Download invoice
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={toggleTrackingDetailsViewModal}
              >
                <i className="bx bxs-truck font-size-18" id="trackingbutton" />
                <UncontrolledTooltip placement="top" target="trackingbutton">
                  Shipment Details
                </UncontrolledTooltip>
              </Link> */}
            </div>
          );
        },
      },
    ],
    []
  );

  document.title = "Individual Customer Orders | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Orders"
            breadcrumbItem="Individual Customer Orders"
          />
          <EcommerceOrdersModal
            isOpen={orderDetailsModel}
            toggle={toggleViewModal}
          />
          <EcommerceOrdersPaymentModal
            isOpen={paymentDetailsModel}
            toggle={togglePaymentDetailsViewModal}
          />
          <EcommerceOrdersTrackingModal
            isOpen={trackingDetailsModel}
            toggle={toggleTrackingDetailsViewModal}
          />
          <Row>
            <Col lg="12">
            <div className="status-filter-wrapper">
            <select name="filter"
                  className="status-filter"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
        <option value="">All</option>
        <option value="Order Placed">Order Placed</option>
        <option value="Order in Progress">Order in Progress</option>
        <option value="Delivered">Delivered</option>
        <option value="Pending">Pending</option>
        <option value="Cancel">Cancel</option>
      </select></div>
              <TableContainer
                columns={columns}
                data={filteredData}
                isGlobalFilter={true}
                customPageSize={10}
                className="custom-header-css"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default IndividualOrder;
